import React from 'react';
import { Badge, Tooltip, Group, Text } from '@mantine/core';
import { IconWifi, IconWifiOff } from '@tabler/icons-react';
import { useWebSocket } from '../../contexts/WebSocketContext';

interface RealtimeIndicatorProps {
  showText?: boolean;
  size?: 'xs' | 'sm' | 'md' | 'lg';
}

export const RealtimeIndicator: React.FC<RealtimeIndicatorProps> = ({ 
  showText = false,
  size = 'sm' 
}) => {
  const { isConnected } = useWebSocket();

  const icon = isConnected ? (
    <IconWifi size={size === 'xs' ? 12 : size === 'sm' ? 14 : size === 'md' ? 16 : 18} />
  ) : (
    <IconWifiOff size={size === 'xs' ? 12 : size === 'sm' ? 14 : size === 'md' ? 16 : 18} />
  );

  const badge = (
    <Badge
      size={size}
      variant={isConnected ? 'dot' : 'filled'}
      color={isConnected ? 'green' : 'red'}
      leftSection={showText ? undefined : icon}
    >
      {showText && (
        <Group gap={4}>
          {icon}
          <Text size={size}>
            {isConnected ? 'Live' : 'Offline'}
          </Text>
        </Group>
      )}
    </Badge>
  );

  return (
    <Tooltip
      label={isConnected ? 'Real-time updates active' : 'Real-time updates disconnected'}
      position="bottom"
      withArrow
    >
      {badge}
    </Tooltip>
  );
};

export default RealtimeIndicator;